function Ctrl($scope, $location, metaTagService) {
  metaTagService.set({
    title: '404 | Tablelist',
    description: 'Tablelist provides instant access to VIP bottle service, private tables and exclusive events in a growing number of cities across the country.',
    statusCode: 404
  });

  const params = $location.search();

  if (params && params.message) {
    $scope.message = params.message;
  }
}

Ctrl.$inject = [
  '$scope',
  '$location',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/errorNotFound/errorNotFoundCtrl.js